import Vue from 'vue'
import Router from 'vue-router'
import Wrap from '@/views/Wrap'
import Hello from '@/components/Hello'
import Login from '@/views/Login'
import Main from '@/views/Main'
import dashboard from '@/views/dashboard'
import Coach from './coach'
import Course from './course'
import Activity from './activity'
import Program from './program'
import whiteList from './whiteList'
import Manufacturer from './manufacturer'
import User from './user'
import Admin from './admin'
import Dealer from './dealer'
import Shop from './shop'
import Staff from './staff'
import Client from './client'
import devtools from '@/views/devtools'

Vue.use(Router)
const router = new Router({
  mode: "hash",
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello,
      redirect: '/dealer/login'
    }, {
      path: '/devtools',
      name: '开发工具',
      component: devtools//,
      //redirect: '/main'
    },
    Admin,
    Dealer,
    Shop,
    Staff,
    Client,
    {
      path: "/other",
      name: "平台",
      component: Wrap,
      redirect: "other/main",
      children: [
        {
          path: 'login/',
          name: '登录',
          component: Login
        },
        {
          path: 'main',
          name: '首页',
          component: Main,
          redirect: 'main/index',
          children: [
            {
              name: '主页',
              path: 'index',
              meta: { hideBreadcrumb: true },
              component: dashboard
            },
            Coach,
            Program,
            whiteList,
            Manufacturer,
            Course,
            Activity,
            User,
            {
              path: 'member/edit',
              name: '编辑会员',
              component: require('@/views/member/edit')
            },
            {
              path: 'user/password',
              name: '修改密码',
              component: require('@/views/user/password')
            }
          ]
        }
      ]
    }

  ]
})
router.beforeEach((to, from, next) => {
  next();
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js